import { render, staticRenderFns } from "./OAuthLogin.vue?vue&type=template&id=65c3e5d0&scoped=true&lang=pug&"
import script from "./OAuthLogin.vue?vue&type=script&lang=js&"
export * from "./OAuthLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c3e5d0",
  null
  
)

export default component.exports